import { error } from 'services/graphql/fragments/Fragments';
import { AnalyticsEventFragment } from 'services/graphql/fragments/HomeTilesContentFragment';
import { gql } from 'urql';

const getOfferChoices = gql`
  query GetOfferChoices {
    offerChoices {
      __typename
      ... on OfferChoicesSuccess {
        id
        offersPageTitle: title
        subTitle
        bodyItems {
          __typename
          id
          iconUrl
          title
          onActivateAnalytics {
            ...AnalyticsEventFragment
          }
        }
        buttonTitle
        displayAnalytics {
          ...AnalyticsEventFragment
        }
      }
      ... on OfferChoicesError {
        ...error
      }
    }
  }
  ${error}
  ${AnalyticsEventFragment}
`;

export default getOfferChoices;
